var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPackagesinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-.86603 -.5 -.86603 .5 137 47.692)",
    fill: "#FFDBC0",
    stroke: "#000",
    strokeWidth: 1.645,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0 0h65.24v65.24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-.86603 -.5 -.86603 .5 137 47.693)",
    fill: "#FFDBC0",
    stroke: "#000",
    strokeWidth: 1.645,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0 0h30.794v65.24H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-.86603 -.5 -.86603 .5 128.605 47.532)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.645,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0 0h11.921v15.508H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-.86603 -.5 -.86603 .5 113.048 62.062)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.645,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0 0h66.322v8.842H0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-.86603 .5 0 1 137 47.692)",
    fill: "#FFB681",
    stroke: "#000",
    strokeWidth: 1.645,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0 0h65.24v65.24H0z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.86603 .5 0 1 24 47.692)",
    fill: "#E0A173",
    stroke: "#000",
    strokeWidth: 1.645,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0 0h65.24v65.24H0z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.86603 .5 0 1 44.259 70.035)",
    fill: "#4E4E4E",
    stroke: "#000",
    strokeWidth: 1.645,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0 0h18.456v7.929H0z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-.86603 .5 0 1 112.704 61.703)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.645,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0 0h9.067v22.052H0z"
  })));
}

export default SvgPackagesinline;